import React,{Component} from "react";
import Header from "../components/Header";


class Agency extends React.Component{
    render(){
        return(
            <div>

                  {/*<!-- Header Container -->*/}
				  <Header agency="current"/>
                  {/*<!-- Header Container / End -->*/}

                 {/*<!-- Titlebar -->*/}
                 <div className="parallax titlebar" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1160.24px", backgroundPosition:"50% -550.067px"}}>
                   <div className="parallax-overlay" style={{backgroundColor:"rgb(48, 48, 48)", opacity: "0.8"}}></div>
                   <div id="titlebar">
                     <div className="container">
                       <div className="row">
                         <div className="col-md-12">
                           <h2>Agency List</h2>
                           {/*<!-- Breadcrumbs -->*/}
                           <nav id="breadcrumbs">
                             <ul>
                               <li><a href="index.html">Home</a></li>
                               <li>Agency List</li>
                             </ul>
                           </nav>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                 
                 {/*<!-- Content -->*/}
                 <div className="container">
                   <div className="row">
                     <div className="col-md-6"> 
                       {/*<!-- Agency -->*/}
                       <div className="agent agents-profile agency"> <a href="agency-profile.html" className="utf-agent-avatar"> <img src="assets/images/agency-01.jpg" alt=""/> </a>
                         <div className="utf-agent-content">
                           <div className="utf-agent-name">
               			  <p className="text-alt">Agent</p>
               			  <div className="fp_pdate">2 Hour Ago</div>
                             <h4><a href="agency-profile.html">Modern House Real Estate</a></h4>
                             <ul className="utf-agent-contact-details">
               			      <li><i className="icon-material-outline-business"></i>Afghanistan</li>
               				  <li><i className="icon-feather-smartphone"></i>(+21) 124 123 4546</li>
               				  <li><i className="icon-material-outline-email"></i><a href="#">demo@example.com</a></li>
               			  </ul> 
               			  <ul className="utf-social-icons">
               				  <li><a className="facebook" href="#"><i className="icon-facebook"></i></a></li>
               				  <li><a className="twitter" href="#"><i className="icon-twitter"></i></a></li>
               				  <li><a className="linkedin" href="#"><i className="icon-linkedin"></i></a></li>
               				  <li><a className="instagram" href="#"><i className="icon-instagram"></i></a></li>
               				  <li><a className="gplus" href="#"><i className="icon-gplus"></i></a></li>
               			  </ul>
               			</div>
               			<div className="clearfix"></div>
                           <p>Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text.</p>                      
                         </div>
                       </div>
               	  </div>	
               	  
               	  <div className="col-md-6"> 
                       {/*<!-- Agency -->*/}
                       <div className="agent agents-profile agency"> <a href="agency-profile.html" className="utf-agent-avatar"> <img src="assets/images/agency-02.jpg" alt=""/> </a>
                         <div className="utf-agent-content">
                           <div className="utf-agent-name">
               			  <p className="text-alt">Agent</p>	
               			  <div className="fp_pdate">2 Hour Ago</div>
                             <h4><a href="agency-profile.html">House Real Estate</a></h4>
                             <ul className="utf-agent-contact-details">
               			      <li><i className="icon-material-outline-business"></i>Afghanistan</li>
               				  <li><i className="icon-feather-smartphone"></i>(+21) 124 123 4546</li>
               				  <li><i className="icon-material-outline-email"></i><a href="#">demo@example.com</a></li>
               			  </ul> 
               			  <ul className="utf-social-icons">
               				  <li><a className="facebook" href="#"><i className="icon-facebook"></i></a></li>
               				  <li><a className="twitter" href="#"><i className="icon-twitter"></i></a></li>
               				  <li><a className="linkedin" href="#"><i className="icon-linkedin"></i></a></li>
               				  <li><a className="instagram" href="#"><i className="icon-instagram"></i></a></li>
               				  <li><a className="gplus" href="#"><i className="icon-gplus"></i></a></li>
               			  </ul>
               			</div>
               			<div className="clearfix"></div>
                           <p>Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text.</p>                      
                         </div>
                       </div>
               	  </div>
               	  
               	  <div className="col-md-6"> 
                       {/*<!-- Agency -->*/}
                       <div className="agent agents-profile agency"> <a href="agency-profile.html" className="utf-agent-avatar"> <img src="assets/images/agency-03.jpg" alt=""/> </a>
                         <div className="utf-agent-content">
                           <div className="utf-agent-name">
               			  <p className="text-alt">Agent</p>
               			  <div className="fp_pdate">2 Hour Ago</div>
                             <h4><a href="agency-profile.html">High-Rise Real Estate</a></h4>
                             <ul className="utf-agent-contact-details">
               			      <li><i className="icon-material-outline-business"></i>Afghanistan</li>
               				  <li><i className="icon-feather-smartphone"></i>(+21) 124 123 4546</li>
               				  <li><i className="icon-material-outline-email"></i><a href="#">demo@example.com</a></li>
               			  </ul> 
               			  <ul className="utf-social-icons">
               				  <li><a className="facebook" href="#"><i className="icon-facebook"></i></a></li>
               				  <li><a className="twitter" href="#"><i className="icon-twitter"></i></a></li>
               				  <li><a className="linkedin" href="#"><i className="icon-linkedin"></i></a></li>
               				  <li><a className="instagram" href="#"><i className="icon-instagram"></i></a></li>
               				  <li><a className="gplus" href="#"><i className="icon-gplus"></i></a></li>
               			  </ul>
               			</div>
               			<div className="clearfix"></div>
                           <p>Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text.</p>                      
                         </div>
                       </div>
               	  </div>
               	  
               	  <div className="col-md-6"> 
                       {/*<!-- Agency -->*/}
                       <div className="agent agents-profile agency"> <a href="agency-profile.html" className="utf-agent-avatar"> <img src="assets/images/agency-04.jpg" alt=""/> </a>
                         <div className="utf-agent-content">
                           <div className="utf-agent-name">
               			  <p className="text-alt">Agent</p>
               			  <div className="fp_pdate">2 Hour Ago</div>
                             <h4><a href="agency-profile.html">Country House Real Estate</a></h4>
                             <ul className="utf-agent-contact-details">
               			      <li><i className="icon-material-outline-business"></i>Afghanistan</li>
               				  <li><i className="icon-feather-smartphone"></i>(+21) 124 123 4546</li>
               				  <li><i className="icon-material-outline-email"></i><a href="#">demo@example.com</a></li>
               			  </ul> 
               			  <ul className="utf-social-icons">
               				  <li><a className="facebook" href="#"><i className="icon-facebook"></i></a></li>
               				  <li><a className="twitter" href="#"><i className="icon-twitter"></i></a></li>
               				  <li><a className="linkedin" href="#"><i className="icon-linkedin"></i></a></li>
               				  <li><a className="instagram" href="#"><i className="icon-instagram"></i></a></li>
               				  <li><a className="gplus" href="#"><i className="icon-gplus"></i></a></li>
               			  </ul>
               			</div>
               			<div className="clearfix"></div>
                           <p>Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text.</p>                      
                         </div>
                       </div>
               	  </div>
                       
                     <div className="col-md-12">
                       <div className="clearfix"></div>
                       {/*<!-- Pagination -->*/}
                       <div className="utf-pagination-container margin-top-20">
                         <nav className="pagination">
                           <ul>
                             <li><a href="#"><i className="fa fa-angle-left"></i></a></li>
               			  <li><a href="#" className="current-page">1</a></li>
                             <li><a href="#">2</a></li>
                             <li><a href="#">3</a></li>
                             <li className="blank">...</li>
                             <li><a href="#">10</a></li>
               			  <li><a href="#"><i className="fa fa-angle-right"></i></a></li>
                           </ul>
                         </nav>
                       </div>
                       {/*<!-- Pagination / End -->*/} 
                     </div>
                   </div>
                 </div>
                 <div style={{paddingTop:"15px", paddingBottom:"15px",}}></div> 

            </div>
        )
    }
}

export default Agency;